import { Span } from '@/components/atoms'

type ToastVariant = 'success' | 'error' | 'info'

const variantClass: Record<ToastVariant, string> = {
  success: 'alert-success',
  error: 'alert-error',
  info: 'alert-info',
}

interface ToastProps {
  message: string
  variant?: ToastVariant
  onDismiss: () => void
}

export function Toast({ message, variant = 'info', onDismiss }: ToastProps) {
  return (
    <div
      role="alert"
      className={`alert ${variantClass[variant]} alert-outline my-4 flex justify-between`}
    >
      <Span data-testid="toast-message">{message}</Span>
      <button onClick={onDismiss} className="text-lg leading-none font-bold">
        ×
      </button>
    </div>
  )
}
